module.exports = __webpack_public_path__ + "242aa683b8a7c268b92bd322595447ad.jpg";